export default __webpack_public_path__ + "assets/fonts/f90997deeaba2b1def7ec99b02f1aaaa.woff";